import React, { createContext, useContext, useState, useCallback } from "react";

export const MobileNavContext = createContext({
  open: false,
  toggle: () => {},
});

export const useMobileNavContext = () => {
  const context = useContext(MobileNavContext);

  if (!context) throw Error("No mobile menu context provided");

  return context;
};

export const MobileNavProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => {
    setOpen(!open);
  }, [open, setOpen]);

  return (
    <MobileNavContext.Provider value={{ toggle, open }}>
      {children}
    </MobileNavContext.Provider>
  );
};
